import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DashboardTileType } from '@store';
import { DashboardInstallationUrls } from '../../../../../+installations/installations-routing.helper';
import { CommonStandaloneModule } from '../../../../../shared/common-standalone.module';
import { DashboardNavigationHelperService } from '../../../dashboard-navigation-helper.service';
import { TileNavigationActionItem } from '../../../dashboard.model';

@Component({
  selector: 'app-tile-modal-footer-actions',
  standalone: true,
  imports: [forwardRef(() => CommonStandaloneModule)],
  templateUrl: './tile-modal-footer-actions.component.html',
  styleUrls: ['./tile-modal-footer-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileModalFooterActionsComponent implements OnInit {
  @Input() tileType: DashboardTileType;
  @Output() closeDialog = new EventEmitter<void>();
  tileNavigationActionItem: TileNavigationActionItem;
  protected readonly deviceMonitoringLink = `/${DashboardInstallationUrls.List}/${DashboardInstallationUrls.Board}`;

  constructor(private dashboardNavigationHelperService: DashboardNavigationHelperService) {}

  ngOnInit(): void {
    this.tileNavigationActionItem = this.dashboardNavigationHelperService.getNavigationActionItem(
      this.tileType
    );
  }

  onNavigationClick(): void {
    this.dashboardNavigationHelperService.navigate(this.tileNavigationActionItem);
    this.closeDialog.next();
  }

  onCloseClick(): void {
    this.closeDialog.next();
  }
}
